export default __webpack_public_path__ + "static/bokinglogo-1adb14a6a763235e8d2eff343d58b59b.png";